import React from 'react';
import { ApMenu, ApMenuItem, ApButtonIcon } from '@alixpartners/ui-components';
import { Text, Wrapper } from './ContextualMenu.styles';
import { DangerText } from './ContextualMenu.styles';

export const ContextualMenu = ({
	onClose,
	isOpen,
	toggleMenu,
	showModuleInfo,
	handleModuleInformation,
	id,
	moduleName,
	handleModuleDelete,
}) => {
	return (
		<Wrapper>
			<ApMenu
				onClose={onClose}
				isOpen={isOpen}
				toggleMenu={toggleMenu}
				placement="bottom-start"
				button={
					<ApButtonIcon
						iconName="outline_more_vert"
						onClick={e => e.stopPropagation()}
					/>
				}
			>
				<ApMenuItem
					onClick={() => {
						showModuleInfo(state => !state);
						handleModuleInformation(id, moduleName);
					}}
				>
					<Text>View Info</Text>
				</ApMenuItem>
				<ApMenuItem onClick={() => handleModuleDelete(id, moduleName)}>
					<DangerText>Delete Module</DangerText>
				</ApMenuItem>
			</ApMenu>
		</Wrapper>
	);
};

export default ContextualMenu;
